import {Button, Grid, IconButton, Link} from '@material-ui/core';
import {RouteComponentProps} from '@reach/router';
import {SnackbarKey, useSnackbar} from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import React, {useEffect, useRef, useState} from 'react';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {buildEntityDropdown} from '../../Components/UniversalRListTable/Filters/buildEntityDropdown';
import {
  ImportResponseMessages,
  joinMessages,
  responseToImportSuccessBuilder,
} from '../../Helpers/ApiRequestHelper';
import {apiService} from '../../Helpers/apiService';
import {uriGenerator} from '../../Helpers/UriGenerator';
import {LMessages} from '../../Localization/Localization';

/**
 * Import result card.
 * @returns {JSX.Element}
 * @constructor
 */
export default function ImportCard({}: RouteComponentProps) {
  const [eventId, setEvent] = useState<string>('0');
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const errorSnackKeysRef = useRef<SnackbarKey[]>([]);

  // Close only error snackbars created on this page when navigating away
  useEffect(() => {
    return () => {
      errorSnackKeysRef.current.forEach((key) => closeSnackbar(key));
    };
  }, [closeSnackbar]);

  // is_open 2 = events.is_open "Открыт для загрузки": only events open to upload are offered
  const eventFilter = buildEntityDropdown('EVENT_LIST', 3,
    eventId, setEvent, {params: {is_open: 2}})();

  const onChange = (event: any) => {
    const file = event.target.files[0];
    const data = new FormData();
    data.append('import', file);

    const {api, redirect} = uriGenerator(
      {action: 'RESULTS_IMPORT', id: eventId});

    const messages: ImportResponseMessages = {
      1: LMessages.RESULT_IMPORT_SUCCESS,
      5: LMessages.RESULT_IMPORT_CONFLICT,
    };
    const responseWithMessage = responseToImportSuccessBuilder(
      messages,
      enqueueSnackbar,
      redirect,
    );
    apiService.post(api, data)
      .then(responseWithMessage)
      .catch((response) => {
        const error = response.response.data.errors;
        const key = enqueueSnackbar(joinMessages(error), {
          variant: 'error',
          persist: true,
          action: (snackKey) => (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => closeSnackbar(snackKey)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ),
        });
        errorSnackKeysRef.current.push(key);
      });
  };

  const {api: downloadUri} = uriGenerator({action: 'RESULTS_DOWNLOAD_BLANK'});

  return (
    <React.Fragment>
      <PageTitle
        title={`Импорт результатов`}/>
      <RowOfButtons>
        <Grid item>
          <Link href={downloadUri}>
            Скачать шаблон
          </Link>
        </Grid>
      </RowOfButtons>

      <CardContainer>
        <div>
          <form>
            {eventFilter}
            <Button
              disabled={eventId === '0'}
              color="primary"
              variant="contained"
              fullWidth
              component="label"
            >
              Загрузить
              <input
                onChange={onChange}
                type="file"
                hidden
              />
            </Button>
          </form>
        </div>
      </CardContainer>

    </React.Fragment>
  );
}
